export default "__VITE_ASSET__bvmZf2YX__"